// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3ylDC","list":"styles_list__y6xuh"};